import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface OfertaAtivaHistProps extends QueryGlobalInterface {
  enabled?: boolean;
  idLeadCorretor?: string;
}

export function useOfertaAtivaHist(props: OfertaAtivaHistProps) {
  const fetchData = async () => {
    const OFERTA_ATIVA_HIST = `leads/common/campanha/listar-campanhas-contempladas-lead/v1?idLeadCorretor365=${props.idLeadCorretor}`;
    const response = await instance.get(OFERTA_ATIVA_HIST);

    return response?.data || null;
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled !== undefined ? props.enabled : false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar histórico de ofertas. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}
